<button (click)="openRightPanel(tempRef)" color="primary" mat-button>Password dimenticata?</button>
<ng-template #tempRef>
  <app-sidenav [title]="'recupera password'">
    <form [formGroup]="recoverPasswordForm">
      <div class="col-12 p-0">
        <app-input-text [form]="recoverPasswordForm" [hint]="instructions" icon="mail" label="E-mail"
                        name="email" placeholder="m.rossi@mail.to"></app-input-text>
      </div>
    </form>
    <div footer>
      <div class="flex justify-content-center p-1 pb-2">
        <app-primary-button (click)="onRecoverPasswordClick()" [disabled]="!recoverPasswordForm.valid"
                            label="Recupera password"></app-primary-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>
